// test2967
(2967 && 0);
